import React from 'react'
import PropTypes from 'prop-types'
import { size, truncate, get } from 'lodash'
import sanitizeHtml from 'sanitize-html'

import { Typography } from '@material-ui/core'

import PreviewModal from './PreviewModal'

import './index.scss'

export const MAX_MESSAGE_LENGTH = 115

export default class Message extends React.Component {
  static propTypes = {
    outreachItem: PropTypes.object.isRequired,
  }
  state = {
    show: false,
  }
  render() {
    const { outreachItem } = this.props
    const originalMessage = get(outreachItem, 'Message')
    const subject = get(outreachItem, 'Subject')
    const message =
      size(originalMessage) > MAX_MESSAGE_LENGTH
        ? truncate(originalMessage, {
            length: MAX_MESSAGE_LENGTH,
            omission: '...',
          })
        : originalMessage
    return (
      <div className="outreach-message">
        <a
          className="view-more-button"
          onClick={() => this.setState({ show: true })}
          onKeyPress={(e) => e.key === 'Enter' && this.setState({ show: true })}
          tabIndex={0}
        >
          {subject}
        </a>
        <div>
          <Typography
            component="div"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(message) }}
          />
        </div>
        <PreviewModal
          show={this.state.show}
          outreachItem={outreachItem}
          onClose={() => this.setState({ show: false })}
        />
      </div>
    )
  }
}
